import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypesByEventId, getCountries } from "ticketino-api-client";

import Header from './components/Header'
import Footer from "./components/Footer";

import iconStarDoubleLeft from "../images/icons/star_double_left.svg"
import iconArrowUp from "../images/icons/arrow_up.svg"

const Home = () => {
    // Toggle this to open/close registration
    const REGISTRATION_OPEN = true;

    const [orderId, setOrderId] = useState();

    const [ticketTypeIdRegister, setTicketTypeIdRegister] = useState(0);

    const [eventId, setEventId] = useState(0);
    const [posId, setPosId] = useState(0);
    const [organizerId, setOrganizerId] = useState(0);

    const [orderLoaded, setOrderLoaded] = useState(false);
    const [tokenLoaded, setTokenLoaded] = useState(false);

    const [isDisableTextBox, setIsDisableTextBox] = useState(false);
    //const [isDisableTextBoxEmail, setIsDisableTextBoxEmail] = useState(false);

    const [errors, setErrors] = useState("");

    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        company: "",
        email: "",
        mobile: "",
        street: "",
        city: "",
        postCode: "",
        countryId: 176,
        code1: "", //imported
        code2: "", //imported
        code3: "", //imported
        code4: "", //imported
        code5: "", //imported
        code6: "", //standort
        code7: "", //arrival
        code8: "", //food
        code9: "", //allergies
        code10: "", //imported
        code11: "", //imported
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [countries, setCountries] = useState([]);

    // fetching params
    const { language, code } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotions", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        // Scroll to the registration section when content is loaded
        if (!loading) {
            setTimeout(() => {
                registrationRef.current?.scrollIntoView({
                    behavior: 'auto',
                    block: 'start'
                });
            }, 100);
        }
    }, [loading]); // Trigger when loading state changes

    useEffect(() => {
        requestResources();

        // so it wont get called on first load
        if (orderLoaded) {
            startOrder(posId, eventId);
        }
        if (tokenLoaded) {
            loadCountries();
        }

    }, [language, tokenLoaded]); //everytime language is changed

    useEffect(() => {
        if (code && tokenLoaded && organizerId && organizerId !== 0 && orderId && orderId !== 0) {
            applyPromotionCodeToOrder(orderId, code);
            loadAddress(orderId, code);
        }
    }, [code, tokenLoaded, orderId, organizerId]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            setTokenLoaded(true);
            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID etc
            setOrganizerId(res.data.organizerId);
            setPosId(res.data.posId);
            setEventId(res.data.eventId);
            setTicketTypeIdRegister(res.data.registrationTicketTypeId);

            // Check if we already have an order stored
            const existingOrderId = sessionStorage.getItem("orderId");
            if (existingOrderId && existingOrderId !== "0") {
                setOrderId(existingOrderId);
                setOrderLoaded(true);
            } else {
                startOrder(res.data.posId, res.data.eventId);
            }
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadCountries = async () => {
        try {
            let countries = await getCountries(language);

            const indexCH = countries.findIndex(c => c.id === 176);
            const ch = countries[indexCH];
            countries.splice(indexCH, 1);

            var indexDE = countries.findIndex(c => c.id === 229);
            const de = countries[indexDE];
            countries.splice(indexDE, 1);

            var indexAU = countries.findIndex(c => c.id === 228);
            const au = countries[indexAU];
            countries.splice(indexAU, 1);

            countries.unshift({ id: 0, name: "---------" });
            countries.unshift(au);
            countries.unshift(de);
            countries.unshift(ch);

            setCountries(countries);
        }
        catch (error) {
            console.error(error);
        }
    }

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 5,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setOrderLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);

            const unlockedTicketTypes = response.data.unlockedTicketTypes;

            // Must have exactly one ticket type
            if (unlockedTicketTypes.length !== 1) {
                navigate(`/${language}/invalid`);
                return;
            }

            // Set the ticket type ID
            setTicketTypeIdRegister(unlockedTicketTypes[0]);

            return response.data;
        } catch (error) {
            console.error(error.response.data);
            if (error.response.status < 200 || error.response.status >= 300) {
                navigate(`/${language}/invalid`);
            }
        }
    }

    const getAddressOfPromotionCode = async (promotionCode, organizerId) => {
        try {
            const res = await axios.get(`${baseUrl}/PromotionCode/${promotionCode}/Address?organizerId=${organizerId}`);
            return res.data;
        } catch (error) {
            console.error(error);
        }
    }

    const loadAddress = async (orderId, code) => {
        try {
            let updatedAddress = {};

            try {
                updatedAddress = await getAddressOfPromotionCode(code, organizerId);
            } catch { }

            if (updatedAddress) {

                let location = updatedAddress.code2;

                if (location != "Luzern/Littau") {
                    location = updatedAddress.code2?.substring(5)  //location without PLZ
                }

                setBuyerInfo((prevBuyerInfo) => ({
                    ...prevBuyerInfo,
                    salutation: updatedAddress.salutation,
                    firstName: updatedAddress.firstName,
                    name: updatedAddress.name,
                    company: updatedAddress.company,
                    email: updatedAddress.email?.trim(),
                    mobile: updatedAddress.mobile,
                    street: updatedAddress.street,
                    city: updatedAddress.city,
                    postCode: updatedAddress.postCode,
                    countryId: updatedAddress.countryId,
                    code1: updatedAddress.code1,
                    code2: updatedAddress.code2,
                    code3: updatedAddress.code3,
                    code4: updatedAddress.code4,
                    code6: location,
                    code5: updatedAddress.code5,
                    code10: updatedAddress.code10,
                    code11: updatedAddress.code11,
                }));

                // Store firstName in sessionStorage for confirmation page
                sessionStorage.setItem("buyerFirstName", updatedAddress.firstName?.trim() || "");

                setIsDisableTextBox(true);

                //if (updatedAddress.email !== "" && updatedAddress.email !== null) {
                //    setIsDisableTextBoxEmail(true);
                //}
            }

            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    }

    const addTicketToBasket = async (ticketTypeId) => {

        let addTicketTypes = [];

        let countryId = Number(buyerInfo.countryId); // Convert to number if necessary
        let country = countries.find(c => c.id === countryId);

        addTicketTypes.push({
            ticketTypeId: ticketTypeId,
            quantity: 1,
            firstname: buyerInfo.firstName,
            lastname: buyerInfo.name,
            company: buyerInfo.company,
            email: buyerInfo.email,
            mobile: buyerInfo.mobile,
            street: buyerInfo.street,
            postCode: buyerInfo.postCode,
            city: buyerInfo.city,
            country: country.name,
            option1: buyerInfo.code1,
            option2: buyerInfo.code2,
            option3: buyerInfo.code3,
            option4: buyerInfo.code4,
            option5: buyerInfo.code5,
            option6: buyerInfo.code6, //location without PLZ
            option7: buyerInfo.code7,
            option8: buyerInfo.code8,
            option9: buyerInfo.code9,
            option10: buyerInfo.code10,
            option11: buyerInfo.code11,
            promotionCode: code
        });

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                //// gtm - addToCart
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({
                //    'event': 'addToCart'
                //});
                addAddressToBasket();
            })
            .catch((error) => {
                console.error(error.response.data);

                sessionStorage.removeItem("orderId");
                setOrderId(null);
                setOrderLoaded(false);

                //if order is missing start a new one
                startOrder(posId, eventId);
            });
    };

    const addAddressToBasket = async () => {
        // Trim all string values before submitting

        let salutationEmailValue = resources.BuyerSalutationMrValue;

        if (buyerInfo.salutation === "Frau") {
            salutationEmailValue = resources.BuyerSalutationMsValue;
        } 

        let addressBody = {
            ...buyerInfo,
            firstName: buyerInfo.firstName?.trim() || "",
            name: buyerInfo.name?.trim() || "",
            company: buyerInfo.company?.trim() || "",
            email: buyerInfo.email?.trim() || "",
            mobile: buyerInfo.mobile?.trim() || "",
            street: buyerInfo.street?.trim() || "",
            city: buyerInfo.city?.trim() || "",
            postCode: buyerInfo.postCode?.trim() || "",
            code1: buyerInfo.code1?.trim() || "",
            code2: buyerInfo.code2?.trim() || "",
            code3: buyerInfo.code3?.trim() || "",
            code4: buyerInfo.code4?.trim() || "",
            code5: buyerInfo.code5?.trim() || "",
            code6: buyerInfo.code6?.trim() || "",
            code7: buyerInfo.code7?.trim() || "",
            code8: buyerInfo.code8?.trim() || "",
            code9: buyerInfo.code9?.trim() || "",
            code10: buyerInfo.code10?.trim() || "",
            code11: buyerInfo.code11?.trim() || "",
            code15: salutationEmailValue,
            languageId: languageId
        };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {
                //// gtm - addAddress
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({
                //    'event': 'addAddress'
                //});
                finishFreeOrder();
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const finishFreeOrder = async () => {
        await axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(() => {
                confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    };

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
        } catch (error) {
            console.error(error)
        }
    };

    const onSubmit = async () => {
        if (isSubmitting) return; // Prevent double submission

        if (validateEntries()) {
            setIsSubmitting(true);
            try {
                await addTicketToBasket(ticketTypeIdRegister);
            } catch (error) {
                console.error(error);
                setIsSubmitting(false); // Re-enable on error
            }
            // Note: Don't reset isSubmitting on success since we navigate away
        }
    };

    const onInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setBuyerInfo((prevBuyerInfo) => {
            return { ...prevBuyerInfo, [name]: type === 'checkbox' ? checked : value };
        });
    };

    const validateEntries = () => {

        if (!(buyerInfo.firstName && buyerInfo.firstName.trim() && /^.{1,70}$/.test(buyerInfo.firstName.trim())) ||
            !(buyerInfo.name && buyerInfo.name.trim() && /^.{1,70}$/.test(buyerInfo.name.trim())) ||
            !(buyerInfo.code7 && buyerInfo.code7.trim() && /^.{1,70}$/.test(buyerInfo.code7.trim())) ||
            !(buyerInfo.code8 && buyerInfo.code8.trim() && /^.{1,70}$/.test(buyerInfo.code8.trim()))) {
            setErrors(resources?.BuyerFillMandatoryFields);
            return false;
        }
        else if (!(buyerInfo.email && buyerInfo.email.trim() && /^\S+@\S+\.\S+$/.test(buyerInfo.email.trim()))) {
            setErrors(resources?.BuyerFillMandatoryEmail);
            return false;
        }

        setErrors("");
        return true;
    }

    const registrationRef = useRef(null);

    const scrollToRegistration = () => {
        registrationRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div>
            {!loading &&
                <>
                    <Header
                        firstName={buyerInfo?.firstName}
                        onScrollToRegistration={scrollToRegistration}
                        registrationOpen={REGISTRATION_OPEN}
                    />
                    <div className="container page-container ps-4 pe-4">

                        {!REGISTRATION_OPEN ? (
                            // Closed registration message
                            <div className="row title-margin-top" ref={registrationRef}>
                                <div className="col-md-12 text-center">
                                    <img src={iconStarDoubleLeft} className="icon-star-double-left" alt="" />
                                    <span className="title">{resources?.BuyerTitle}</span>
                                </div>
                                <div className="col-md-12 mt-5 text-center">
                                <p className="fs-5">{resources?._ClosedRegistration}</p>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* Registration */}
                                <div className="row title-margin-top" ref={registrationRef}>
                            <div className="col-md-12 text-center">
                                <img src={iconStarDoubleLeft} className="icon-star-double-left" alt="" />
                                <span className="title">{resources?.BuyerTitle}</span>
                            </div>
                            <div className="col-md-12 mt-4 text-center">
                                <span dangerouslySetInnerHTML={{ __html: resources?.BuyerTitleDescription }}></span>
                            </div>
                        </div>

                        {/* First Name */}
                        <div className="row mt-4">
                            <div className="col-12 mt-1 f-black"><label htmlFor="firstName">{resources?.BuyerFirstname} *</label></div>
                            <div className="col-12 mt-1">
                                <input
                                    type="text"
                                    name="firstName"
                                    className="form-control"
                                    placeholder={resources?.BuyerFirstname}
                                    value={buyerInfo.firstName}
                                    id="firstName"
                                    onChange={onInputChange}
                                />
                            </div>
                        </div>

                        {/* Last Name */}
                        <div className="row mt-4">
                            <div className="col-12 mt-1 f-black"><label htmlFor="name">{resources?.BuyerLastname} *</label></div>
                            <div className="col-12 mt-1">
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    placeholder={resources?.BuyerLastname}
                                    value={buyerInfo.name}
                                    id="name"
                                    onChange={onInputChange}
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="row mt-4">
                            <div className="col-12 mt-1 f-black"><label htmlFor="email">{resources?.BuyerEmail} *</label></div>
                            <div className="col-12 mt-1">
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    placeholder={resources?.BuyerEmail}
                                    value={buyerInfo.email}
                                    id="email"
                                    onChange={onInputChange}
                                />
                            </div>
                        </div>

                        {/* Location */}
                        <div className="row mt-4">
                            <div className="col-12 mt-1 f-black"><label htmlFor="code6">{resources?.BuyerLocation} *</label></div>
                            <div className="col-12 mt-1">
                                <input
                                    type="text"
                                    name="code6"
                                    className="form-control"
                                    placeholder={resources?.BuyerLocation}
                                    value={buyerInfo.code6}
                                    id="code6"
                                    onChange={onInputChange}
                                    disabled={buyerInfo.code6 !== "" && buyerInfo.code6 !== null}
                                />
                            </div>
                        </div>

                        {/* Food */}
                        <div className="row mt-4">
                            <div className="col-12 mt-1 f-black"><label>{resources?.BuyerFood} *</label></div>
                            <div className="col-12 mt-1">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="code8"
                                        id="foodAll"
                                        value={resources?.BuyerFoodAll}
                                        checked={buyerInfo.code8 === resources?.BuyerFoodAll}
                                        onChange={onInputChange}
                                    />
                                    <label className="form-check-label" htmlFor="foodAll">
                                        ... {resources?.BuyerFoodAll}.
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="code8"
                                        id="foodVegan"
                                        value={resources?.BuyerFoodVegan}
                                        checked={buyerInfo.code8 === resources?.BuyerFoodVegan}
                                        onChange={onInputChange}
                                    />
                                    <label className="form-check-label" htmlFor="foodVegan">
                                        ... {resources?.BuyerFoodVegan}.
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="code8"
                                        id="foodVegetarian"
                                        value={resources?.BuyerFoodVegetarian}
                                        checked={buyerInfo.code8 === resources?.BuyerFoodVegetarian}
                                        onChange={onInputChange}
                                    />
                                    <label className="form-check-label" htmlFor="foodVegetarian">
                                        ... {resources?.BuyerFoodVegetarian}.
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Allergies */}
                        <div className="row mt-2">
                            <div className="col-12 mt-1"><label htmlFor="code9">{resources?.BuyerFoodAllergies}</label></div>
                            <div className="col-12 mt-1">
                                <input
                                    type="text"
                                    name="code9"
                                    className="form-control"
                                    placeholder={resources?.BuyerFoodAllergiesPlaceholder}
                                    value={buyerInfo.code9}
                                    id="code9"
                                    onChange={onInputChange}
                                />
                            </div>
                        </div>


                        {/* Arrival */}
                        <div className="row mt-4">
                            <div className="col-12 mt-1 f-black"><label htmlFor="code7">{resources?.BuyerArrival} *</label></div>
                            <div className="col-12 mt-1">
                                <select
                                    className="form-select"
                                    aria-label=""
                                    id="code7"
                                    name="code7"
                                    value={buyerInfo.code7}
                                    onChange={onInputChange}
                                >
                                    <option value="">{resources?.BuyerChoose}</option>
                                    <option value={resources?.BuyerArrival1}>{resources?.BuyerArrival1}</option>
                                    <option value={resources?.BuyerArrival2}>{resources?.BuyerArrival2}</option>
                                </select>
                            </div>
                        </div>

                        <div className="row mt-5 ">
                            <div className="col-12">
                                <button
                                    className="button-cutom button"
                                    onClick={() => onSubmit()
                                    }
                                    disabled={isSubmitting}
                                >
                                    {resources?.BuyerRegister}
                                </button>
                            </div>
                        </div>

                        {errors !== "" && (
                            <div className="row text-start mt-4">
                                <div className="offset-md-6 col-md-6"></div>
                                <p className="text-danger ps-2">*{errors}</p>
                            </div>
                        )}
                            </>
                        )}
                    </div>

                    <Footer language={language} />

                    {/* Scroll to top button */}
                    <button
                        className="scroll-to-top"
                        onClick={scrollToTop}
                        aria-label="Scroll to top"
                    >
                        <img src={iconArrowUp} alt="Scroll to top" />
                    </button>
                </>
            }
        </div>
    )
}

export default Home